"use strict";

exports.boolConj = function (b1) {
  return function (b2) {
    return b1 && b2;
  };
};

exports.boolDisj = function (b1) {
  return function (b2) {
    return b1 || b2;
  };
};

exports.boolNot = function (b) {
  return !b;
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.HeytingAlgebra/foreign.js
// module id = 295
// module chunks = 0